"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_schema_types_1 = require("@aurora/shared-generated/types/graphql-schema-types");
const types_1 = require("./types");
class LightItalicStyle {
    constructor() {
        this.name = types_1.FontStyleName.LIGHTITALIC;
        this.style = graphql_schema_types_1.FontStyle.Italic;
        this.weight = 300;
    }
}
exports.default = LightItalicStyle;
//# sourceMappingURL=LightItalicStyle.js.map